<script>

	import {joinUserToCompany} from "../../../../api/joinUserToCompany";

	export let colaboratorsList = null;


	async function allowUserToCompany(e){

		console.log(e);

		var userID = e.target.getAttribute('name');
		var status = e.target.id;
		var company = null;

		/******/
		var user = await localStorage.getItem('user');
		user =  JSON.parse(user);

		// console.log(user);

		if(user){
			company = user.company;
		}

		/******/

		var data = {
			CompanyName: company,
			Email: userID,
			Status: status
		}

		console.log(data);


		var res = await joinUserToCompany(data);

		if(res.status == 'valid'){
			window.location.reload();
		}
		else if(res.status == 'error'){
			//handle error
		}
	}

</script>

<div class="companyColaboratorsContainer">
	<div class="titleContainer">
		<div class="title">
			Company colaborators:
		</div>
	</div>

	<div class="colaboratorsList">
		{#if colaboratorsList != null}
			{#each colaboratorsList as colaborator, index}
				{#if colaborator.status}
					<div class="colaboratorPendingItem">
						<div class="colaboratorPendingItemText" >{colaborator.ID}</div>

						<div class="colaboratorPendingItemActionBtnContainer">
							<div class="actionBtn" id="deny" name={colaborator.ID} on:click={(e) => allowUserToCompany(e)} >
								<i class="fa-regular fa-circle-xmark" id="deny" name={colaborator.ID}></i>
							</div>

							<div class="actionBtn" id="accept" name={colaborator.ID} on:click={(e) => allowUserToCompany(e)}>
								<i class="fa-regular fa-circle-check" id="accept" name={colaborator.ID}></i>
							</div>
						</div>
					</div>
				{:else}
					<div class="colaboratorItem">{colaborator.ID}</div>
				{/if}
				
				
			{/each}
		{/if}
	</div>

</div>


<style>
	

.companyColaboratorsContainer{
	width: 100%;
	height: 100%;
	/*background-color: orange;*/
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-top: 3%;
}

.titleContainer{
	width: 100%;
	height: 10%;
	display: flex;
	align-items: center;
	justify-content: center;
	/*background-color: red;*/
}

.title{
	width: 80%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	color: black;
	font-size: 0.9114583333333334vw;
	font-weight: 700;
	opacity: 0.8;
	/*background-color: orange;*/
}


.colaboratorsList{
	width: 98%;
	height: 90%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-end;
	/*background-color: red;*/
	gap: 5%;
	margin-top: 1%;
}


.colaboratorItem{
	width: 90%;
	height: 5.54016620498615vh;
	border: 1px solid white;
	border-radius: 3px;
	background-color: transparent;
	color: black;
	font-size: 0.9114583333333334vw;
	font-weight: 700;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
	transform: translateY(-5px);
}

.colaboratorPendingItem{
	width: 90%;
	height: 8.310249307479225vh;
	border: 1px solid white;
	border-radius: 3px;
	background-color: transparent;
	color: black;
	font-size: 0.9114583333333334vw;
	font-weight: 700;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
	transform: translateY(-5px);
}

.colaboratorPendingItemText{
	width: 100%;
	height: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: black;
	font-size: 0.9114583333333334vw;
	font-weight: 700;
}

.colaboratorPendingItemActionBtnContainer{
	width: 100%;
	height: 50%;
	display: flex;
	flex-direction: row;

}

.actionBtn{
	width: 50%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}


</style>